import { useEffect, useState } from "react";
import { PublicLayout } from "@/components/site/PublicLayout";
import { Breadcrumbs } from "@/components/site/Breadcrumbs";
import { api, fileUrl } from "@/lib/api";
import { Calendar, MapPin, User } from "lucide-react";
import { format } from "date-fns";

export default function Events() {
    const [scope, setScope] = useState("upcoming");
    const [events, setEvents] = useState([]);
    useEffect(() => { api.get("/events", { params: { scope } }).then((r) => setEvents(r.data)); }, [scope]);

    return (
        <PublicLayout>
            <section className="container-x pt-10">
                <Breadcrumbs items={[{ label: "Events" }]} />
                <div className="mt-5 flex flex-wrap items-end justify-between gap-4">
                    <div>
                        <div className="overline">Association Calendar</div>
                        <h1 className="mt-3 font-serif text-5xl text-slate-900 sm:text-6xl">Events</h1>
                        <p className="mt-4 max-w-2xl text-lg text-slate-600">From annual general meetings to festivals and community drives.</p>
                    </div>
                    <div className="inline-flex rounded-full border border-slate-200 bg-white p-1 text-sm">
                        {["upcoming", "past"].map((s) => (
                            <button
                                key={s}
                                onClick={() => setScope(s)}
                                className={`rounded-full px-4 py-1.5 capitalize ${scope === s ? "bg-brand-blue text-white" : "text-slate-700"}`}
                                data-testid={`events-scope-${s}`}
                            >{s}</button>
                        ))}
                    </div>
                </div>
            </section>

            <section className="container-x mt-10 pb-20">
                <div className="grid gap-6 md:grid-cols-2">
                    {events.map((e) => (
                        <article key={e.id} className="surface-card-hover overflow-hidden" data-testid={`event-${e.id}`}>
                            <div className="relative h-44 bg-gradient-to-br from-brand-blue via-brand-blue-dark to-slate-900">
                                {e.banner_id ? (
                                    <img src={fileUrl(e.banner_id)} alt={e.title} className="h-full w-full object-cover" loading="lazy" />
                                ) : (
                                    <div className="grid h-full place-items-center text-white/40"><Calendar size={48} /></div>
                                )}
                                <div className="absolute right-4 top-4 rounded-2xl bg-white p-3 text-center shadow-md">
                                    <div className="text-[10px] font-semibold uppercase tracking-wider text-brand-orange">{e.date ? format(new Date(e.date), "MMM") : ""}</div>
                                    <div className="font-serif text-2xl text-slate-900">{e.date ? format(new Date(e.date), "dd") : ""}</div>
                                </div>
                            </div>
                            <div className="p-6">
                                <div className="font-serif text-2xl text-slate-900">{e.title}</div>
                                <div className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-xs text-slate-500">
                                    {e.venue && <span className="inline-flex items-center gap-1"><MapPin size={12} /> {e.venue}</span>}
                                    {e.organizer && <span className="inline-flex items-center gap-1"><User size={12} /> {e.organizer}</span>}
                                </div>
                                <p className="mt-3 leading-relaxed text-slate-600">{e.description}</p>
                            </div>
                        </article>
                    ))}
                    {events.length === 0 && <div className="col-span-full py-16 text-center text-slate-500">No {scope} events.</div>}
                </div>
            </section>
        </PublicLayout>
    );
}
